import React from 'react';
import { CreditCard } from 'lucide-react';

interface CheckoutPaymentMethodProps {
  handlePaymentMethodChange: (method: string) => void;
  selectedMethod: string;
}

export function CheckoutPaymentMethod({ handlePaymentMethodChange, selectedMethod }: CheckoutPaymentMethodProps) {
  const paymentMethods = [
    {
      id: 'bank_link',
      name: 'Pangamakse (Swedbank, SEB, LHV, ja teised)', 
      description: 'Turvaline pangamakse läbi Esto maksesüsteemi',
      icon: <CreditCard className="w-5 h-5 mr-2" />
    },
    {
      id: 'esto_jarelmaks',
      name: 'ESTO järelmaks',
      description: 'Maksa osadena kuni 60 kuud, 0€ lepingutasu',
      icon: (
        <div className="flex items-center mr-3">
          <img 
            src="https://res.cloudinary.com/daka2lob2/image/upload/v1751272738/ESTO_jarelmaks_be56fw.png" 
            alt="ESTO järelmaks" 
            className="h-12 w-auto object-contain"
            onError={(e) => {
              const target = e.target as HTMLImageElement;
              target.style.display = 'none';
            }}
          />
          <div className="ml-3 text-sm">
            <div className="font-semibold text-gray-800">Kuni 60 kuud</div>
            <div className="text-gray-600">0€ lepingutasu!</div>
          </div>
        </div>
      )
    },
    {
      id: 'regular_transfer',
      name: 'Tavaline ülekanne', 
      description: 'Tavapärane ülekanne pangakontolt',
      icon: null
    }
  ];

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold mb-4">Vali makseviis</h2>
      <div className="space-y-4">
        {paymentMethods.map((method) => (
          <label 
            key={method.id} 
            className={`flex items-center p-4 border rounded-lg cursor-pointer transition-colors ${
              selectedMethod === method.name 
                ? 'border-[#4FC1E9] bg-[#4FC1E9]/5' 
                : 'hover:border-[#4FC1E9]'
            }`}
          >
            <input
              type="radio"
              name="paymentMethod"
              value={method.name}
              checked={selectedMethod === method.name}
              onChange={(e) => handlePaymentMethodChange(e.target.value)}
              className="text-[#4FC1E9] focus:ring-[#4FC1E9]"
            />
            <div className="ml-3 flex-1">
              <div className="font-medium flex items-center">
                {method.icon}
                {method.id !== 'esto_jarelmaks' && method.name}
              </div>
              {method.description && method.id !== 'esto_jarelmaks' && (
                <p className="text-sm text-gray-500 mt-1">{method.description}</p>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  );
}